/* Astetica Chat Embed (Embedded Page Version)
 * For use on dedicated chat pages (no floating launcher)
 * Includes full image upload support with thumbnails
 */

(function () {
  'use strict';

  const API_ENDPOINT = 'https://asteticachatbot-production.up.railway.app/chat';

  function isLocalhost() {
    return (
      location.hostname === 'localhost' ||
      location.hostname === '127.0.0.1'
    );
  }

  // ---------- Inject CSS ----------
  const style = document.createElement('style');
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@300;400;500;600&display=swap');

    /* Enforce Josefin Sans font across all chat elements */
    #astetica-chatbot-window,
    #astetica-chatbot-window *:not(svg):not(img):not(#astetica-chatbot-header img) {
      font-family: 'Josefin Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
    }

    /* Main container - embedded in page */
    #astetica-chatbot-window {
      width: 100%;
      max-width: 800px;
      height: 600px;
      margin: 0 auto 72px auto;
      background: linear-gradient(
        120deg,
        #050506 0%,
        #151518 25%,
        #2D2627 65%,
        #3C302C 100%
      ) !important;
      border-radius: 28px !important;
      border: 1px solid #555555 !important;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    /* Chat Header */
    #astetica-chatbot-header {
      background: linear-gradient(
        180deg,
        #000000 0%,
        #242426 100%
      ) !important;
      color: #ECE9E4;
      padding: 20px 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: "Josefin Sans", sans-serif;
      border-bottom: 1px solid rgba(236, 233, 228, 0.3);
    }

    #astetica-chatbot-header-content {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    #astetica-chatbot-header-title {
      font-weight: 600;
      font-size: 18px;
      margin: 0 0 4px 0;
      color: #FFFFFF !important;
      font-family: 'Josefin Sans', sans-serif;
    }

    #astetica-chatbot-header-subtitle {
      font-weight: 300;
      font-size: 12px;
      margin: 0;
      color: #FFFFFF !important;
      opacity: 0.7;
      font-family: 'Josefin Sans', sans-serif;
    }

    #astetica-chatbot-header img {
      color: #FFFFFF !important;
      fill: #FFFFFF !important;
    }

    /* Messages Area */
    #astetica-chatbot-messages {
      flex: 1;
      overflow-y: auto;
      padding: 20px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      background: linear-gradient(
        180deg,
        #000000 0%,
        #242426 100%
      ) !important;
      color: #FFFFFF;
      scrollbar-color: #ECE9E4 #1c1c1c;
      scrollbar-width: thin;
    }

    #astetica-chatbot-messages::-webkit-scrollbar {
      width: 10px;
    }

    #astetica-chatbot-messages::-webkit-scrollbar-track {
      background-color: #1c1c1c !important;
    }

    #astetica-chatbot-messages::-webkit-scrollbar-thumb {
      background-color: #ECE9E4;
      border-radius: 10px;
      box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.25);
    }

    #astetica-chatbot-messages::-webkit-scrollbar-thumb:hover {
      background-color: rgba(236, 233, 228, 0.9);
    }

    .astetica-chatbot-message {
      max-width: 80%;
      padding: 12px 16px;
      border-radius: 18px;
      word-wrap: break-word;
      font-size: 13px;
      line-height: 1.6;
      font-family: "Josefin Sans", sans-serif;
    }

    .astetica-chatbot-message.astetica-chatbot-user {
      align-self: flex-end;
      background-color: #F8D6D9 !important;
      color: #000000 !important;
      border-bottom-right-radius: 4px;
      font-weight: 400;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .astetica-chatbot-message-image {
      max-width: 200px;
      max-height: 200px;
      border-radius: 8px;
      object-fit: cover;
      margin-top: 4px;
      cursor: pointer;
    }

    .astetica-chatbot-message.astetica-chatbot-assistant {
      align-self: flex-start;
      background-color: #ECE9E4 !important;
      color: #000000 !important;
      border: none;
      border-bottom-left-radius: 4px;
      font-weight: 400;
    }

    .astetica-chatbot-message.astetica-chatbot-typing {
      align-self: flex-start;
      background-color: #ECE9E4 !important;
      color: #000000 !important;
      font-style: italic;
      border: none;
      border-bottom-left-radius: 4px;
      opacity: 0.8;
    }

    #astetica-chatbot-typing-indicator .astetica-chatbot-typing-dots {
      display: inline-block;
    }

    #astetica-chatbot-typing-indicator .astetica-chatbot-typing-dots span {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #000000;
      margin: 0 2px;
      animation: astetica-chatbot-typing-bounce 1.4s infinite ease-in-out;
      opacity: 0.6;
    }

    #astetica-chatbot-typing-indicator .astetica-chatbot-typing-dots span:nth-child(1) {
      animation-delay: -0.32s;
    }

    #astetica-chatbot-typing-indicator .astetica-chatbot-typing-dots span:nth-child(2) {
      animation-delay: -0.16s;
    }

    @keyframes astetica-chatbot-typing-bounce {
      0%, 80%, 100% {
        transform: scale(0.8);
        opacity: 0.4;
      }
      40% {
        transform: scale(1);
        opacity: 0.8;
      }
    }

    /* Input Area */
    #astetica-chatbot-input-area {
      padding: 12px 16px 16px 16px;
      display: flex;
      flex-direction: column;
      background-color: #242425 !important;
      border: none;
      border-top: 1px solid #555555;
      border-radius: 0 0 26px 26px !important;
      box-sizing: border-box !important;
      gap: 8px;
    }

    /* Thumbnail previews container */
    #astetica-chatbot-thumbs {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      width: 100%;
      order: -1;
    }

    .astetica-chatbot-thumb-wrapper {
      position: relative;
      display: inline-block;
      width: 60px;
      height: 60px;
    }

    .astetica-chatbot-thumb {
      width: 60px;
      height: 60px;
      border-radius: 8px;
      object-fit: cover;
      box-shadow: 0 0 4px rgba(0,0,0,0.25);
      display: block;
    }

    /* Input bar row container */
    #astetica-chatbot-input-row {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 100%;
    }

    /* Attach button */
    #astetica-chatbot-attach {
      background-color: #ECE9E4;
      color: #000000;
      border: none;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      min-width: 32px;
      padding: 0;
      cursor: pointer;
      transition: all 0.2s ease;
      font-family: "Josefin Sans", sans-serif;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    }

    #astetica-chatbot-attach:hover {
      background-color: rgba(236, 233, 228, 0.95);
      transform: scale(1.05);
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);
    }

    #astetica-chatbot-attach:active {
      transform: scale(0.95);
    }

    #astetica-chatbot-file-input {
      display: none;
    }

    /* Input pill */
    #astetica-chatbot-input-bar {
      flex: 1;
      min-width: 0;
      background-color: #242425 !important;
      border-radius: 999px !important;
      border: 0.2px solid #555555 !important;
      box-sizing: border-box !important;
      display: flex;
      align-items: center;
      padding: 8px 8px 8px 20px;
      gap: 8px;
    }

    #astetica-chatbot-input {
      flex: 1;
      padding: 0;
      border: none !important;
      border-radius: 0;
      font-size: 14px;
      outline: none;
      font-family: "Josefin Sans", sans-serif;
      background-color: transparent !important;
      color: #F6F1E9 !important;
      transition: all 0.2s ease;
      min-width: 0;
    }

    #astetica-chatbot-input:focus {
      outline: none !important;
      box-shadow: none !important;
      background: transparent !important;
    }

    #astetica-chatbot-input::placeholder {
      color: #8F8C90 !important;
    }

    #astetica-chatbot-send {
      background-color: #ECE9E4;
      color: #000000;
      border: none;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      min-width: 32px;
      padding: 0;
      cursor: pointer;
      transition: all 0.2s ease;
      font-family: "Josefin Sans", sans-serif;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    #astetica-chatbot-send:hover:not(:disabled) {
      background-color: rgba(236, 233, 228, 0.95);
      transform: scale(1.05);
    }

    #astetica-chatbot-send:active:not(:disabled) {
      transform: scale(0.95);
    }

    #astetica-chatbot-send:disabled {
      background-color: rgba(236, 233, 228, 0.3);
      color: rgba(0, 0, 0, 0.4);
      cursor: not-allowed;
      transform: none;
    }

    /* SVG Icon Styles */
    .astetica-chatbot-icon {
      display: block;
    }

    .astetica-chatbot-icon-plus,
    .astetica-chatbot-icon-arrow {
      width: 60%;
      height: auto;
    }

    .astetica-chatbot-icon-plus line,
    .astetica-chatbot-icon-arrow line,
    .astetica-chatbot-icon-arrow polyline {
      stroke: #000000;
      stroke-width: 2.2;
      stroke-linecap: round;
      stroke-linejoin: round;
      fill: none;
    }

    .astetica-chatbot-icon-arrow line,
    .astetica-chatbot-icon-arrow polyline {
      stroke-width: 2.4;
    }

    /* Close button - unified style */
    .astetica-x-btn {
      background: rgba(236, 233, 228, 0.20);
      border: none;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .astetica-x-btn svg {
      width: 18px;
      height: 18px;
    }

    .astetica-x-btn svg line {
      stroke: #000000;
      stroke-width: 2.6;
      stroke-linecap: round;
    }

    #astetica-chatbot-close {
      width: 32px;
      height: 32px;
      background: rgba(236, 233, 228, 0.35);
      border-radius: 50%;
      color: #000000;
      transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
    }

    #astetica-chatbot-close:hover {
      background: rgba(236, 233, 228, 0.6);
      transform: rotate(90deg) scale(1.05);
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.45);
    }

    #astetica-chatbot-close:active {
      transform: rotate(90deg) scale(0.95);
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
    }

    /* Thumbnail remove button - unified style */
    .astetica-chatbot-thumb-remove {
      position: absolute;
      top: -6px;
      right: -6px;
      width: 22px;
      height: 22px;
      background: rgba(236, 233, 228, 0.35);
      border-radius: 50%;
      color: #000000;
      transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
    }

    .astetica-chatbot-thumb-remove:hover {
      background: rgba(236, 233, 228, 0.6);
      transform: rotate(90deg) scale(1.05);
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.45);
    }

    .astetica-chatbot-thumb-remove:active {
      transform: rotate(90deg) scale(0.95);
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
    }
  `;
  document.head.appendChild(style);

  // ---------- Inject HTML ----------
  const targetContainer = document.getElementById('astetica-ai-embed');
  if (!targetContainer) {
    console.error('Astetica chat embed: #astetica-ai-embed element not found. Chat will not render.');
    return;
  }

  const container = document.createElement('div');
  container.id = 'astetica-chatbot-window';
  container.innerHTML = `
    <div id="astetica-chatbot-header">
      <div id="astetica-chatbot-header-content">
        <img
          src="https://cdn.shopify.com/s/files/1/0870/1722/6571/files/Astetica_Ai_widget_3.png?v=1764199557"
          alt="Astetica Icon"
          style="
            width: 72px;
            height: 72px;
            margin-right: 14px;
            flex-shrink: 0;
            display: block;
            object-fit: cover;
            border-radius: 50%;
          "
        />
        <div>
          <div id="astetica-chatbot-header-title">Astetica AI Assistant</div>
          <div id="astetica-chatbot-header-subtitle">Here to help with products, prescriptions, delivery & the aesthetics industry.</div>
        </div>
      </div>
    </div>
    
    <div id="astetica-chatbot-messages"></div>
    
    <div id="astetica-chatbot-input-area">
      <div id="astetica-chatbot-thumbs"></div>
      <div id="astetica-chatbot-input-row">
        <button id="astetica-chatbot-attach" aria-label="Attach image">
          <svg class="astetica-chatbot-icon astetica-chatbot-icon-plus" viewBox="0 0 24 24" aria-hidden="true">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </button>
        <input 
          type="file" 
          id="astetica-chatbot-file-input" 
          multiple 
          accept="image/*"
          aria-label="File input"
        />
        <div id="astetica-chatbot-input-bar">
          <input 
            type="text" 
            id="astetica-chatbot-input" 
            placeholder="Type your message..."
            aria-label="Message input"
          />
          <button id="astetica-chatbot-send" aria-label="Send message">
            <svg class="astetica-chatbot-icon astetica-chatbot-icon-arrow" viewBox="0 0 24 24" aria-hidden="true">
              <line x1="12" y1="19" x2="12" y2="5" />
              <polyline points="6 11, 12 5, 18 11" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  `;
  targetContainer.appendChild(container);

  // Get DOM elements
  const messagesEl = document.getElementById('astetica-chatbot-messages');
  const inputEl = document.getElementById('astetica-chatbot-input');
  const sendBtn = document.getElementById('astetica-chatbot-send');
  const attachBtn = document.getElementById('astetica-chatbot-attach');
  const fileInput = document.getElementById('astetica-chatbot-file-input');
  const thumbsContainer = document.getElementById('astetica-chatbot-thumbs');

  // Store selected images as data URLs
  let embedSelectedImages = [];

  // ---------- Helper: Convert FileList to data URLs ----------
  function readFilesAsDataUrls(fileList) {
    return Promise.all(
      Array.from(fileList).map(file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      })
    );
  }

  // ---------- Render thumbnails with remove buttons ----------
  function renderThumbnails() {
    thumbsContainer.innerHTML = '';
    embedSelectedImages.forEach((dataUrl, index) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'astetica-chatbot-thumb-wrapper';
      
      const thumb = document.createElement('img');
      thumb.src = dataUrl;
      thumb.className = 'astetica-chatbot-thumb';
      thumb.alt = 'Selected image';
      
      const removeBtn = document.createElement('button');
      removeBtn.className = 'astetica-x-btn astetica-chatbot-thumb-remove';
      removeBtn.setAttribute('aria-label', 'Remove image');
      removeBtn.type = 'button';
      removeBtn.innerHTML = `
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <line x1="5" y1="5" x2="19" y2="19" />
          <line x1="5" y1="19" x2="19" y2="5" />
        </svg>
      `;
      removeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        embedSelectedImages.splice(index, 1);
        renderThumbnails();
      });
      
      wrapper.appendChild(thumb);
      wrapper.appendChild(removeBtn);
      thumbsContainer.appendChild(wrapper);
    });
  }

  // ---------- Image upload handling ----------
  attachBtn.addEventListener('click', function () {
    fileInput.click();
  });

  fileInput.addEventListener('change', async function (event) {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    try {
      const dataUrls = await readFilesAsDataUrls(files);
      embedSelectedImages = embedSelectedImages.concat(dataUrls);
      renderThumbnails();
    } catch (e) {
      console.error('Error reading files:', e);
      if (isLocalhost()) {
        alert('Error reading image files. Please try again.');
      }
    }
    
    fileInput.value = '';
  });

  // ---------- Message functions ----------
  function appendMessage(text, from, images) {
    const messageDiv = document.createElement('div');
    messageDiv.className = 'astetica-chatbot-message astetica-chatbot-' + (from === 'user' ? 'user' : 'assistant');
    
    if (text) {
      const textNode = document.createTextNode(text);
      messageDiv.appendChild(textNode);
    }
    
    if (images && images.length > 0) {
      images.forEach(dataUrl => {
        const img = document.createElement('img');
        img.src = dataUrl;
        img.className = 'astetica-chatbot-message-image';
        img.alt = 'User uploaded image';
        messageDiv.appendChild(img);
      });
    }
    
    messagesEl.appendChild(messageDiv);
    setTimeout(() => {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }, 0);
  }

  function showTyping() {
    const typingDiv = document.getElementById('astetica-chatbot-typing-indicator');
    if (typingDiv) {
      typingDiv.remove();
    }
    
    const newTypingDiv = document.createElement('div');
    newTypingDiv.className = 'astetica-chatbot-message astetica-chatbot-typing';
    newTypingDiv.id = 'astetica-chatbot-typing-indicator';
    
    const dotsContainer = document.createElement('span');
    dotsContainer.className = 'astetica-chatbot-typing-dots';
    dotsContainer.innerHTML = '<span></span><span></span><span></span>';
    
    const label = document.createTextNode('Astetica is typing');
    newTypingDiv.appendChild(label);
    newTypingDiv.appendChild(dotsContainer);
    
    messagesEl.appendChild(newTypingDiv);
    setTimeout(() => {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }, 0);
  }

  function hideTyping() {
    const typingDiv = document.getElementById('astetica-chatbot-typing-indicator');
    if (typingDiv) {
      typingDiv.remove();
    }
  }

  function handleError(e) {
    hideTyping();
    appendMessage(
      'The Astetica assistant is not available right now. Please try again later.',
      'assistant'
    );
    if (isLocalhost()) {
      console.error('Astetica chatbot error:', e);
    }
  }

  // ---------- Send message function ----------
  let isSending = false;
  
  async function sendMessage() {
    if (isSending) return;
    
    const text = inputEl.value.trim();
    
    if (!text && embedSelectedImages.length === 0) return;

    isSending = true;
    inputEl.disabled = true;
    sendBtn.disabled = true;
    attachBtn.disabled = true;
    
    const imagesToSend = [...embedSelectedImages];
    
    appendMessage(text, 'user', imagesToSend);
    
    inputEl.value = '';
    embedSelectedImages = [];
    renderThumbnails();
    fileInput.value = '';
    
    showTyping();

    try {
      const requestBody = {
        message: text || '',
        source: "embedded_page",
        images: imagesToSend.length > 0 ? imagesToSend : undefined,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null
      };

      if (!requestBody.images) {
        delete requestBody.images;
      }

      const res = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      if (!res.ok) {
        throw new Error('Non-OK response: ' + res.status);
      }

      const data = await res.json();
      hideTyping();
      
      if (data.success === true && data.reply) {
        appendMessage(data.reply, 'assistant');
      } else {
        const reply = data.reply || data.answer || data.message || 'Got it.';
        appendMessage(reply, 'assistant');
      }
      
    } catch (e) {
      handleError(e);
    } finally {
      isSending = false;
      inputEl.disabled = false;
      sendBtn.disabled = false;
      attachBtn.disabled = false;
      setTimeout(() => {
        inputEl.focus();
      }, 100);
    }
  }

  sendBtn.addEventListener('click', function () {
    sendMessage();
  });

  inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  });

  // Initialize on load - no hardcoded greeting, let the model generate it naturally
  // The new system prompt instructs the model to vary greetings and be warm/human-like
  if (!messagesEl.dataset.initialised) {
    messagesEl.dataset.initialised = '1';
    // No hardcoded greeting - let the user start the conversation naturally
  }

  // Focus input on load
  inputEl.focus();
})();
